/**
 * NotFoundPage — freundliche 404-Seite für unbekannte Routen (kein leerer Bildschirm).
 */
import { NavLink } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="max-w-lg mx-auto py-20 px-4 text-center">
      <div className="text-5xl mb-4">🦊</div>
      <h1 className="font-heading text-2xl font-bold text-stone-900 mb-2">Seite nicht gefunden</h1>
      <p className="text-stone-500 mb-6">
        Diese Seite gibt es nicht (mehr). Vielleicht hilft dir einer dieser Wege weiter:
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <NavLink
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-fox-fire text-white font-medium hover:bg-orange-600"
        >
          <Compass size={16} /> Zum Dashboard
        </NavLink>
        <NavLink
          to="/hilfe"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-stone-200 text-stone-600 font-medium hover:bg-stone-50"
        >
          Hilfe & Anleitung <ArrowRight size={15} />
        </NavLink>
      </div>
    </div>
  );
}
